// components/PoiEditor.tsx
import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Stack
} from '@mui/material';
import { api } from "../utils/api.ts";

interface Props {
  open: boolean;
  onClose: () => void;
  displayedUser: User;
  existingPoi: POI | null;
  onSave: (poi: POI) => void;
}

const PoiEditor: React.FC<Props> = ({ open, onClose, displayedUser, existingPoi, onSave }) => {
  const [form, setForm] = useState<Partial<POI>>({});

  useEffect(() => {
    setForm(existingPoi ?? {});
  }, [existingPoi]);

  const handleChange = (key: keyof POI) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm(prev => ({ ...prev, [key]: e.target.value }));
  };

  const handleSubmit = async () => {
    const payload = { ...form, user_id: displayedUser.id };
    const res = existingPoi
      ? await api.put(`/api/pois/${existingPoi.id}`, payload)
      : await api.post("/api/pois", payload);
    onSave(res.data);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{existingPoi ? 'Edit POI' : 'New POI'}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField label="Name" value={form.name ?? ''} onChange={handleChange('name')} required />
          <TextField label="Description" value={form.description ?? ''} onChange={handleChange('description')} />
          <TextField label="Latitude" type="number" value={form.latitude ?? ''} onChange={handleChange('latitude')} required />
          <TextField label="Longitude" type="number" value={form.longitude ?? ''} onChange={handleChange('longitude')} required />
          <TextField label="Radius" type="number" value={form.radius ?? ''} onChange={handleChange('radius')} />
          <TextField label="OSM Reference" value={form.osm_reference ?? ''} onChange={handleChange('osm_reference')} />
          <TextField label="Icon" value={form.icon ?? ''} onChange={handleChange('icon')} />
          <TextField label="Color" value={form.color ?? ''} onChange={handleChange('color')} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PoiEditor;

